module.exports = __webpack_public_path__ + "img/guide28803.ed0d8c57.png";